import createAction from './';

export const DOWNLOAD_MOBILE_APP = createAction('DOWNLOAD_MOBILE_APP');

export const downloadMobileAppTracker = () => ({ type: DOWNLOAD_MOBILE_APP });
